export default {
	types: {
		phone: "Telefone",
	},
};
